import  Class, { ClassCard } from './Class';

function CurrentClass({block, classTime}) {
    if (block) {
        return (
            <ClassCard block={block} />
        )
    } else {
        return (
            <div class="card mt-4 noblock mx-auto" style={{width: "15rem"}}>
        <div class="card-body">
          <h5 class="card-title">{classTime ? "No Current Class" : "Nothing's Next"}</h5>
          <p class="card-text">Free Time</p>
        </div></div>
        )

    }

}

export default CurrentClass;